(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("dayjs"), require("lodash/isEqual"), require("react-motion"), require("@opuscapita/i18n/lib/converters/DateConverter"), require("@opuscapita/react-autocompletes"), require("react-day-picker"), require("react-day-picker/lib/src/DayPicker"), require("react-day-picker/lib/style.css"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "dayjs", "lodash/isEqual", "react-motion", "@opuscapita/i18n/lib/converters/DateConverter", "@opuscapita/react-autocompletes", "react-day-picker", "react-day-picker/lib/src/DayPicker", "react-day-picker/lib/style.css"], factory);
	else if(typeof exports === 'object')
		exports["ReactDates"] = factory(require("react"), require("prop-types"), require("dayjs"), require("lodash/isEqual"), require("react-motion"), require("@opuscapita/i18n/lib/converters/DateConverter"), require("@opuscapita/react-autocompletes"), require("react-day-picker"), require("react-day-picker/lib/src/DayPicker"), require("react-day-picker/lib/style.css"));
	else
		root["ReactDates"] = factory(root["React"], root["prop-types"], root["dayjs"], root["lodash/isEqual"], root["react-motion"], root["@opuscapita/i18n/lib/converters/DateConverter"], root["@opuscapita/react-autocompletes"], root["react-day-picker"], root["react-day-picker/lib/src/DayPicker"], root["react-day-picker/lib/style.css"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_32__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_34__, __WEBPACK_EXTERNAL_MODULE_125__, __WEBPACK_EXTERNAL_MODULE_126__, __WEBPACK_EXTERNAL_MODULE_127__, __WEBPACK_EXTERNAL_MODULE_128__, __WEBPACK_EXTERNAL_MODULE_129__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 130);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var store  = __webpack_require__(87)('wks')
  , uid    = __webpack_require__(45)
  , Symbol = __webpack_require__(2).Symbol;
module.exports = function(name){
  return store[name] || (store[name] =
    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(2)
  , core      = __webpack_require__(4)
  , hide      = __webpack_require__(5)
  , redefine  = __webpack_require__(17)
  , ctx       = __webpack_require__(14)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target && !own)redefine(target, key, out);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var $          = __webpack_require__(6)
  , createDesc = __webpack_require__(42);
module.exports = __webpack_require__(26) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var $Object = Object;
module.exports = {
  create:     $Object.create,
  getProto:   $Object.getPrototypeOf,
  isEnum:     {}.propertyIsEnumerable,
  getDesc:    $Object.getOwnPropertyDescriptor,
  setDesc:    $Object.defineProperty,
  setDescs:   $Object.defineProperties,
  getKeys:    $Object.keys,
  getNames:   $Object.getOwnPropertyNames,
  getSymbols: $Object.getOwnPropertySymbols,
  each:       [].forEach
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locales = undefined;

var _dayjs = __webpack_require__(32);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _en = __webpack_require__(63);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(64);

var _es2 = _interopRequireDefault(_es);

var _de = __webpack_require__(62);

var _de2 = _interopRequireDefault(_de);

var _fi = __webpack_require__(65);

var _fi2 = _interopRequireDefault(_fi);

var _no = __webpack_require__(66);

var _no2 = _interopRequireDefault(_no);

var _ru = __webpack_require__(67);

var _ru2 = _interopRequireDefault(_ru);

var _sv = __webpack_require__(68);

var _sv2 = _interopRequireDefault(_sv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locales = {
  en: _en2.default,
  es: _es2.default,
  de: _de2.default,
  fi: _fi2.default,
  no: _no2.default,
  ru: _ru2.default,
  sv: _sv2.default
};

Object.keys(locales).forEach(function (name) {
  return _dayjs2.default.locale(locales[name], null, true);
});

exports.locales = locales;
exports.default = _dayjs2.default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(24);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// add fake Function#toString
// for correct work wrapped methods / constructors with methods like LoDash isNative
var global    = __webpack_require__(2)
  , hide      = __webpack_require__(5)
  , SRC       = __webpack_require__(45)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(4).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  if(typeof val == 'function'){
    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
    val.hasOwnProperty('name') || hide(val, 'name', key);
  }
  if(O === global){
    O[key] = val;
  } else {
    if(!safe)delete O[key];
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(21)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var overlayOffsetV = 4;

var getCoords = exports.getCoords = function getCoords(elem, showToTop, showToLeft) {
  if (!elem) {
    return { top: 0, left: 0 };
  }

  var rect = elem.getBoundingClientRect();

  return {
    top: showToTop ? rect.top - overlayOffsetV + window.pageYOffset : rect.top + rect.height + overlayOffsetV + window.pageYOffset,

    left: showToLeft ? rect.left + rect.width + document.body.scrollLeft : rect.left + document.body.scrollLeft,

    alwaysLeft: rect.left + rect.width + document.body.scrollLeft
  };
};

var splitProps = exports.splitProps = function splitProps(props) {
  var specificPropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return Object.keys(props).reduce(function (result, propName) {
    var isPropSpecific = specificPropNames.indexOf(propName) >= 0;
    if (isPropSpecific) {
      var _commonProps = _extends({}, result[0]);
      var _specificProps = _extends({}, result[1], _defineProperty({}, propName, props[propName]));
      return [_commonProps, _specificProps];
    }

    var commonProps = _extends({}, result[0], _defineProperty({}, propName, props[propName]));
    var specificProps = _extends({}, result[1]);
    return [commonProps, specificProps];
  }, [{}, {}]);
};

var zeroTime = exports.zeroTime = function zeroTime(date) {
  if (date instanceof Date) {
    date.setHours(0, 0, 0);
  }
  return date;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(5)
  , redefine = __webpack_require__(17)
  , fails    = __webpack_require__(28)
  , defined  = __webpack_require__(10)
  , wks      = __webpack_require__(0);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , original = ''[KEY];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return original.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return original.call(string, this); }
    );
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(60).default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMessage;
var translations = {
  en: {
    'common.DateInput.today': 'Today',
    'common.DateInput.yesterday': 'Yesterday',
    'common.DateInput.tomorrow': 'Tomorrow',
    'common.DateRangeInput.previousWeek': 'Previous week',
    'common.DateRangeInput.nextWeek': 'Next week',
    'common.DateRangeInput.thisWeek': 'This week',
    'common.DateRangeInput.previousMonth': 'Previous month',
    'common.DateRangeInput.last30Days': 'Last 30 days',
    'common.DateRangeInput.thisMonth': 'This month',
    'common.DateRangeInput.nextMonth': 'Next month',
    'common.DateInput.clearValue': 'Clear value'
  },
  de: {
    'common.DateInput.today': 'Heute',
    'common.DateInput.yesterday': 'Gestern',
    'common.DateInput.tomorrow': 'Morgen',
    'common.DateRangeInput.previousWeek': 'Vorherige Woche',
    'common.DateRangeInput.nextWeek': 'Nächste Woche',
    'common.DateRangeInput.thisWeek': 'Diese Woche',
    'common.DateRangeInput.previousMonth': 'Vorheriger Monat',
    'common.DateRangeInput.last30Days': 'Letzte 30 Tagen',
    'common.DateRangeInput.thisMonth': 'Dieser Monat',
    'common.DateRangeInput.nextMonth': 'Nächster Monat',
    'common.DateInput.clearValue': 'Inhalt löschen'
  },
  ru: {
    'common.DateInput.today': 'Сегодня',
    'common.DateInput.yesterday': 'Вчера',
    'common.DateInput.tomorrow': 'Завтра',
    'common.DateRangeInput.previousWeek': 'Предыдущая неделя',
    'common.DateRangeInput.nextWeek': 'Следующая неделя',
    'common.DateRangeInput.thisWeek': 'Эта неделя',
    'common.DateRangeInput.previousMonth': 'Предыдущий месяц',
    'common.DateRangeInput.last30Days': 'Последние 30 дней',
    'common.DateRangeInput.thisMonth': 'Этот месяц',
    'common.DateRangeInput.nextMonth': 'Следующий месяц',
    'common.DateInput.clearValue': ''
  },
  fi: {
    'common.DateInput.today': 'Tänään',
    'common.DateInput.yesterday': 'Eilen',
    'common.DateInput.tomorrow': 'Huomenna',
    'common.DateRangeInput.previousWeek': 'Edellinen viikko',
    'common.DateRangeInput.nextWeek': 'Seuraava viikko',
    'common.DateRangeInput.thisWeek': 'Tämä viikko',
    'common.DateRangeInput.previousMonth': 'Edellinen kuukausi',
    'common.DateRangeInput.last30Days': 'Edelliset 30 päivää',
    'common.DateRangeInput.thisMonth': 'Tämä kuukausi',
    'common.DateRangeInput.nextMonth': 'Seuraava kuukausi',
    'common.DateInput.clearValue': ''
  },
  no: {
    'common.DateInput.today': 'I dag',
    'common.DateInput.yesterday': 'I går',
    'common.DateInput.tomorrow': 'I morgen',
    'common.DateRangeInput.previousWeek': 'Forrige uke',
    'common.DateRangeInput.nextWeek': 'Neste uke',
    'common.DateRangeInput.thisWeek': 'Denne uken',
    'common.DateRangeInput.previousMonth': 'Foregående måned',
    'common.DateRangeInput.last30Days': 'Siste 30 dager',
    'common.DateRangeInput.thisMonth': 'Denne måneden',
    'common.DateRangeInput.nextMonth': 'Neste måned',
    'common.DateInput.clearValue': ''
  },
  sv: {
    'common.DateInput.today': 'Idag',
    'common.DateInput.yesterday': 'Igår',
    'common.DateInput.tomorrow': 'Imorgon',
    'common.DateRangeInput.previousWeek': 'Föregående vecka',
    'common.DateRangeInput.nextWeek': 'Nästa vecka',
    'common.DateRangeInput.thisWeek': 'Denna vecka',
    'common.DateRangeInput.previousMonth': 'Föregående månad',
    'common.DateRangeInput.last30Days': 'SSenaste 30 dagarna',
    'common.DateRangeInput.thisMonth': 'Denna månad',
    'common.DateRangeInput.nextMonth': 'Nästa månad',
    'common.DateInput.clearValue': ''
  }
};

function getMessage(locale, key) {
  var translationExists = translations[locale] && translations[locale][key];

  if (!translationExists) {
    return translations['en'][key];
  }

  return translations[locale][key];
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(13)
  , TAG = __webpack_require__(0)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(28)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(0)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).setDesc
  , has = __webpack_require__(39)
  , TAG = __webpack_require__(0)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(77)
  , defined  = __webpack_require__(10);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(75)
  , defined = __webpack_require__(10);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = require("dayjs");

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = require("lodash/isEqual");

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = require("react-motion");

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(53).default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(58).default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(61).default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(0)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(5)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(41)
  , $export        = __webpack_require__(1)
  , redefine       = __webpack_require__(17)
  , hide           = __webpack_require__(5)
  , has            = __webpack_require__(39)
  , Iterators      = __webpack_require__(16)
  , $iterCreate    = __webpack_require__(79)
  , setToStringTag = __webpack_require__(29)
  , getProto       = __webpack_require__(6).getProto
  , ITERATOR       = __webpack_require__(0)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , methods, key;
  // Fix native
  if($native){
    var IteratorPrototype = getProto($default.call(new Base));
    // Set @@toStringTag to native iterators
    setToStringTag(IteratorPrototype, TAG, true);
    // FF fix
    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES  ? $default : getMethod(VALUES),
      keys:    IS_SET      ? $default : getMethod(KEYS),
      entries: !DEF_VALUES ? $default : getMethod('entries')
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21)
  , defined   = __webpack_require__(10);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(43)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(40)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Here should be es2016 or CommonJS exports.

module.exports = {
  DateInput: __webpack_require__(52).default,
  DateRangeInput: __webpack_require__(57).default,
  DatePicker: __webpack_require__(55).default,
  ModifiersUtils: __webpack_require__(127).ModifiersUtils
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
__webpack_require__(46);
__webpack_require__(110);
__webpack_require__(96);
module.exports = __webpack_require__(4).Promise;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
__webpack_require__(105);
__webpack_require__(108);
__webpack_require__(46);
__webpack_require__(101);
__webpack_require__(102);
__webpack_require__(104);
__webpack_require__(106);
__webpack_require__(107);
__webpack_require__(97);
__webpack_require__(98);
__webpack_require__(99);
__webpack_require__(100);
module.exports = __webpack_require__(4).String;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(4).Array;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(118);

var _DateInputField = __webpack_require__(35);

var _DateInputField2 = _interopRequireDefault(_DateInputField);

var _DayPicker = __webpack_require__(22);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateVariants = __webpack_require__(36);

var _DateVariants2 = _interopRequireDefault(_DateVariants);

var _InputAddonButton = __webpack_require__(37);

var _InputAddonButton2 = _interopRequireDefault(_InputAddonButton);

var _reactMotion = __webpack_require__(34);

var _dayjs = __webpack_require__(11);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _translations = __webpack_require__(23);

var _translations2 = _interopRequireDefault(_translations);

var _isEqual = __webpack_require__(33);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  modifiers: _propTypes2.default.object,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  showVariants: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.object,
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    getLabel: _propTypes2.default.func,
    getValue: _propTypes2.default.func
  }))
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  isValid: true,
  locale: 'en',
  modifiers: {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: null,
  variants: [{
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateInput.yesterday');
    },
    getValue: function getValue(locale) {
      return (0, _dayjs2.default)().locale(locale).subtract(1, 'days').toDate();
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateInput.today');
    },
    getValue: function getValue(locale) {
      return (0, _dayjs2.default)().locale(locale).toDate();
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateInput.tomorrow');
    },
    getValue: function getValue(locale) {
      return (0, _dayjs2.default)().locale(locale).add(1, 'days').toDate();
    }
  }]
};

var DateInput = function (_Component) {
  _inherits(DateInput, _Component);

  function DateInput(props) {
    _classCallCheck(this, DateInput);

    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.pickerContainer.contains(event.target);

      if (_this.variantsContainer) {
        clickedOutside = clickedOutside && !_this.variantsContainer.contains(event.target);
      }

      if (clickedOutside) {
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        _this.hideVariants();
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleVariantsButtonClick = function () {
      var _ret2;

      if (_this.state.showVariants) {
        var _ret;

        return _ret = _this.hideVariants(), _possibleConstructorReturn(_this, _ret);
      }
      return _ret2 = _this.showVariants(), _possibleConstructorReturn(_this, _ret2);
    };

    _this.handleVariantSelect = function (value) {
      _this.hideVariants();
      _this.handleDateChange(value);
    };

    _this.handleError = function (error) {
      _this.setState({ error: error });
    };

    _this.handleDateChange = function (value) {
      _this.props.onChange((0, _utils.zeroTime)(value));
      _this.hidePicker();
      _this.setState({ error: null });
    };

    _this.handleDayClick = function (value, modifiers) {
      if (modifiers.disabled) {
        return _possibleConstructorReturn(_this);
      }

      _this.handleDateChange(value);
    };

    _this.handleInputFocus = function (event) {
      _this.props.onFocus(event);
      _this.showPicker();
    };

    _this.handleInputClick = function () {
      if (!_this.props.disabled) {
        _this.showPicker();
      }
    };

    _this.handleReset = function () {
      _this.setState({ error: null });
      _this.dateInputField.clear();
      _this.hidePicker();
      _this.props.onChange(null);
    };

    _this.handleBlur = function (e) {
      if (_this.state.error) {
        _this.handleReset();
      }
      _this.props.onBlur(e);
    };

    _this.state = {
      error: null,
      showPicker: false,
      showVariants: false
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var month = nextProps.value || new Date();
        if (this.reactDayPicker) {
          this.reactDayPicker.showMonth(month);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.error !== nextState.error || this.state.showPicker !== nextState.showPicker || this.state.showVariants !== nextState.showVariants || this.props.className !== nextProps.className || this.props.dateFormat !== nextProps.dateFormat || this.props.disabled !== nextProps.disabled || this.props.isValid !== nextProps.isValid || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value) || !(0, _isEqual2.default)(this.props.variants, nextProps.variants);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'showVariants',
    value: function showVariants() {
      this.setState({ showVariants: true, showPicker: false });
    }
  }, {
    key: 'hideVariants',
    value: function hideVariants() {
      this.setState({ showVariants: false });
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      var month = this.props.value || new Date();
      this.reactDayPicker.showMonth(month);
      this.hideVariants();
      this.setState({ showPicker: true });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          disabled = _props.disabled,
          isValid = _props.isValid,
          locale = _props.locale,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          showToLeft = _props.showToLeft,
          showToTop = _props.showToTop,
          tabIndex = _props.tabIndex,
          value = _props.value,
          variants = _props.variants,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'disabled', 'isValid', 'locale', 'onBlur', 'onChange', 'onFocus', 'showToLeft', 'showToTop', 'tabIndex', 'value', 'variants']);

      var _state = this.state,
          error = _state.error,
          showPicker = _state.showPicker,
          showVariants = _state.showVariants;


      var dayjsCompatibleDateFormat = dateFormat.replace(/d/g, 'D').replace(/y/g, 'Y');

      var splittedProps = (0, _utils.splitProps)(restProps, Object.keys(_DayPicker2.default.propTypes));
      var dayPickerSpecificProps = splittedProps[1];

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        },
        locale: locale,
        month: value,
        selectedDays: value,
        tabIndex: -1,
        fixedWeeks: true,
        onDayClick: this.handleDayClick,
        onDayKeyDown: this.handleDateChange,
        onDayTouchEnd: this.handleDateChange,
        onChange: this.handleDateChange
      }, dayPickerSpecificProps));

      var showToTopClassName = showToTop ? 'opuscapita_date-input__picker-container--to-top' : '';
      var showToLeftClassName = showToLeft ? 'opuscapita_date-input__picker-container--to-left' : '';

      var hasErrorClassName = error === null && isValid ? '' : 'has-error';

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref) {
                return _this2.pickerContainer = _ref;
              },
              className: '\nopuscapita_date-input__picker-container\n' + showToTopClassName + ' ' + showToLeftClassName + '\n            ',
              style: {
                maxHeight: interpolatedStyle.x * 640 + 'px',
                opacity: easeOutCubic(interpolatedStyle.x)
              }
            },
            pickerElement
          );
        }
      );

      var resetButton = _react2.default.createElement(
        _InputAddonButton2.default,
        {
          className: 'opuscapita_date-input__reset-btn',
          tabIndex: '-1',
          onClick: this.handleReset,
          disabled: disabled,
          title: (0, _translations2.default)(locale, 'common.DateInput.clearValue')
        },
        '\u2715'
      );

      var variantsElement = null;

      if (typeof variants !== 'undefined' && variants.length) {
        var translatedVariants = variants.map(function (variant) {
          return _extends({}, variant, {
            label: variant.getLabel(locale)
          });
        });

        variantsElement = _react2.default.createElement(_DateVariants2.default, {
          onChange: this.handleVariantSelect,
          locale: locale,
          variants: translatedVariants
        });
      }

      var variantsMotionElement = variantsElement ? _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showVariants ? 1 : 0 },
          style: { x: showVariants ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref2) {
                return _this2.variantsContainer = _ref2;
              },
              className: '\n              opuscapita_date-input__variants-container\n              ' + (showToTop ? 'opuscapita_date-input__variants-container--to-top' : '') + '\n            ',
              style: {
                maxHeight: interpolatedStyle.x * 640 + 'px',
                opacity: easeOutCubic(interpolatedStyle.x)
              }
            },
            variantsElement
          );
        }
      ) : null;

      var variantsButton = typeof variants !== 'undefined' && variants.length ? _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-default opuscapita_date-input__variants-btn',
          disabled: disabled,
          tabIndex: '-1',
          onClick: this.handleVariantsButtonClick
        },
        _react2.default.createElement('span', { className: 'caret' })
      ) : null;

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(el) {
            return _this2.container = el;
          },
          className: 'opuscapita_date-input form-control ' + hasErrorClassName + ' ' + className
        },
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_date-input__input-container' },
          _react2.default.createElement(_DateInputField2.default, {
            dateFormat: dayjsCompatibleDateFormat,
            disabled: disabled,
            onBlur: this.handleBlur,
            onChange: this.handleDateChange,
            onClick: this.handleInputClick,
            onError: this.handleError,
            onFocus: this.handleInputFocus,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputField = dateInputField;
            },
            tabIndex: tabIndex,
            value: value
          }),
          resetButton
        ),
        pickerMotionElement,
        variantsMotionElement,
        variantsButton
      );
    }
  }]);

  return DateInput;
}(_react.Component);

exports.default = DateInput;


DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(51).default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _DateConverter = __webpack_require__(125);

var _DateConverter2 = _interopRequireDefault(_DateConverter);

var _dayjs = __webpack_require__(11);

var _dayjs2 = _interopRequireDefault(_dayjs);

__webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onRef: _propTypes2.default.func,
  value: _propTypes2.default.object
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  locale: 'en',
  error: false,
  onChange: function onChange() {},
  onError: function onError() {},
  onRef: function onRef() {},
  value: null
};

var DateInputField = function (_Component) {
  _inherits(DateInputField, _Component);

  function DateInputField(props) {
    _classCallCheck(this, DateInputField);

    var _this = _possibleConstructorReturn(this, (DateInputField.__proto__ || Object.getPrototypeOf(DateInputField)).call(this, props));

    _this.clear = function () {
      _this.setState({ inputValue: '' });
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.target.value;
      _this.validate(inputValue, _this.props.dateFormat);
      _this.setState({ inputValue: inputValue });
    };

    _this.handleRef = function () {
      _this.props.onRef(_this);
    };

    _this.state = {
      inputValue: props.value ? (0, _dayjs2.default)(props.value.toISOString()).format(props.dateFormat) : ''
    };
    return _this;
  }

  _createClass(DateInputField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.error || this.props.value !== nextProps.value || this.props.dateFormat !== nextProps.dateFormat) {
        var inputValue = nextProps.value ? (0, _dayjs2.default)(nextProps.value.toISOString()).format(nextProps.dateFormat) : '';
        this.setState({ inputValue: inputValue });
      }
    }
  }, {
    key: 'validate',
    value: function validate(dateString, dateFormat) {
      var i18nCompatibleFormat = dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y');
      var dc = new _DateConverter2.default(i18nCompatibleFormat);

      try {
        var date = dc.stringToValue(dateString);
        var value = !dateString.length ? null : date;
        this.props.onChange(value);
      } catch (err) {
        this.props.onError(err.message);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          disabled = _props.disabled,
          error = _props.error,
          locale = _props.locale,
          onChange = _props.onChange,
          onError = _props.onError,
          onRef = _props.onRef,
          value = _props.value,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'disabled', 'error', 'locale', 'onChange', 'onError', 'onRef', 'value']);

      var inputValue = this.state.inputValue;


      return _react2.default.createElement(
        'div',
        {
          ref: this.handleRef,
          className: 'opuscapita_date-input-field form-control ' + className,
          disabled: disabled
        },
        _react2.default.createElement('input', _extends({
          ref: function ref(_ref) {
            _this2.dateInputFieldRef = _ref;
          },
          type: 'text',
          className: 'opuscapita_date-input-field__input',
          value: inputValue,
          placeholder: dateFormat,
          disabled: disabled,
          onChange: this.handleInputChange
        }, restProps))
      );
    }
  }]);

  return DateInputField;
}(_react.Component);

exports.default = DateInputField;


DateInputField.propTypes = propTypes;
DateInputField.defaultProps = defaultProps;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(120);

var _DayPicker = __webpack_require__(22);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _reactMotion = __webpack_require__(34);

var _isEqual = __webpack_require__(33);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

var propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  modifiers: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.object
};

var defaultProps = {
  className: '',
  disabled: false,
  locale: 'en',
  modifiers: {},
  onChange: function onChange() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: null
};

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.handleKeyDown = function (event) {
      _this.hidePicker();
    };

    _this.handleDayClick = function (value, modifiers) {
      if (modifiers.disabled) {
        return _possibleConstructorReturn(_this);
      }

      _this.handleDateChange(value);
      _this.hidePicker();
    };

    _this.handleToggleClick = function () {
      if (_this.state.showPicker) {
        _this.hidePicker();
      } else {
        _this.showPicker();
      }
    };

    _this.handleDateChange = function (value) {
      _this.props.onChange((0, _utils.zeroTime)(value));
    };

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.datePickerRef.contains(event.target);

      if (clickedOutside) {
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hidePicker();
      }
    };

    _this.state = {
      showPicker: false
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var month = nextProps.value || new Date();
        if (this.reactDayPicker) {
          this.reactDayPicker.showMonth(month);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.showPicker !== nextState.showPicker || this.props.className !== nextProps.className || this.props.disabled !== nextProps.disabled || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      var month = this.props.value || new Date();
      this.reactDayPicker.showMonth(month);
      this.setState({ showPicker: true });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          locale = _props.locale,
          onChange = _props.onChange,
          showToLeft = _props.showToLeft,
          showToTop = _props.showToTop,
          tabIndex = _props.tabIndex,
          value = _props.value,
          restProps = _objectWithoutProperties(_props, ['className', 'disabled', 'locale', 'onChange', 'showToLeft', 'showToTop', 'tabIndex', 'value']);

      var showPicker = this.state.showPicker;


      var splittedProps = (0, _utils.splitProps)(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var dayPickerSpecificProps = splittedProps[1];

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        },
        locale: locale,
        month: value,
        selectedDays: value,
        tabIndex: -1,
        fixedWeeks: true,
        onDayClick: this.handleDayClick,
        onChange: this.handleDateChange
      }, dayPickerSpecificProps));

      var showToTopClassName = showToTop ? 'opuscapita_date-picker__picker-container--to-top' : '';
      var showToLeftClassName = showToLeft ? 'opuscapita_date-picker__picker-container--to-left' : '';

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref) {
                _this2.datePickerRef = _ref;
              },
              className: '\n              opuscapita_date-picker__picker-container\n              ' + showToTopClassName + ' ' + showToLeftClassName + '\n            ',
              style: {
                maxHeight: interpolatedStyle.x * 640 + 'px',
                opacity: easeOutCubic(interpolatedStyle.x)
              }
            },
            pickerElement
          );
        }
      );

      return _react2.default.createElement(
        'div',
        _extends({
          className: 'opuscapita_date-picker ' + className,
          onKeyDown: this.handleKeyDown,
          ref: function ref(el) {
            return _this2.container = el;
          }
        }, commonProps),
        _react2.default.createElement(
          'button',
          {
            className: 'opuscapita_date-picker__toggle-picker btn btn-default',
            disabled: disabled,
            onClick: this.handleToggleClick,
            tabIndex: tabIndex,
            type: 'button'
          },
          _react2.default.createElement('i', { className: 'fa fa-calendar' })
        ),
        pickerMotionElement
      );
    }
  }]);

  return DatePicker;
}(_react.Component);

exports.default = DatePicker;


DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(54).default;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(121);

var _DayPicker = __webpack_require__(22);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _InputAddonButton = __webpack_require__(37);

var _InputAddonButton2 = _interopRequireDefault(_InputAddonButton);

var _DateVariants = __webpack_require__(36);

var _DateVariants2 = _interopRequireDefault(_DateVariants);

var _DateInputField = __webpack_require__(35);

var _DateInputField2 = _interopRequireDefault(_DateInputField);

var _isEqual = __webpack_require__(33);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _dayjs = __webpack_require__(11);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _reactMotion = __webpack_require__(34);

var _translations = __webpack_require__(23);

var _translations2 = _interopRequireDefault(_translations);

var _utils = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

var initialState = {
  enteredTo: null,
  showPicker: false,
  showVariants: false,
  error: false,
  focused: false
};

function isSelectingFirstDay(from, to, day) {
  var firstDayIsNotSelected = !from;
  var selectedDayIsBeforeFirstDay = day < from;
  var rangeIsSelected = from && to;
  return firstDayIsNotSelected || selectedDayIsBeforeFirstDay || rangeIsSelected;
}

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  modifiers: _propTypes2.default.object,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.array,
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    getLabel: _propTypes2.default.func,
    getValue: _propTypes2.default.func
  }))
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  isValid: true,
  locale: 'en',
  modifiers: {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: [null, null],
  variants: [{
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.previousWeek');
    },
    // TODO remove ternary operator below. Monitor this issue: https://github.com/iamkun/dayjs/issues/215
    getValue: function getValue(locale) {
      return locale === 'en' ? [(0, _dayjs2.default)().locale(locale).subtract(7, 'days').startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).subtract(7, 'days').endOf('week').toDate()] : [(0, _dayjs2.default)().locale(locale).subtract(7, 'days').startOf('week').add(1, 'day').toDate(), (0, _dayjs2.default)().locale(locale).subtract(7, 'days').endOf('week').add(1, 'day').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.thisWeek');
    },
    // TODO remove ternary operator below. Monitor this issue: https://github.com/iamkun/dayjs/issues/215
    getValue: function getValue(locale) {
      return locale === 'en' ? [(0, _dayjs2.default)().locale(locale).startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).endOf('week').toDate()] : [(0, _dayjs2.default)().locale(locale).startOf('week').add(1, 'day').toDate(), (0, _dayjs2.default)().locale(locale).endOf('week').add(1, 'day').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.nextWeek');
    },
    // TODO remove ternary operator below. Monitor this issue: https://github.com/iamkun/dayjs/issues/215
    getValue: function getValue(locale) {
      return locale === 'en' ? [(0, _dayjs2.default)().locale(locale).add(7, 'days').startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).add(7, 'days').endOf('week').toDate()] : [(0, _dayjs2.default)().locale(locale).add(7, 'days').startOf('week').add(1, 'day').toDate(), (0, _dayjs2.default)().locale(locale).add(7, 'days').endOf('week').add(1, 'day').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.previousMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).subtract(1, 'month').startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).subtract(1, 'month').endOf('month').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.last30Days');
    },
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).subtract(30, 'days').toDate(), (0, _dayjs2.default)().locale(locale).toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.thisMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).endOf('month').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'common.DateRangeInput.nextMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).add(1, 'month').startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).add(1, 'month').endOf('month').toDate()];
    }
  }]
};

var DateRangeInput = function (_Component) {
  _inherits(DateRangeInput, _Component);

  function DateRangeInput(props) {
    _classCallCheck(this, DateRangeInput);

    var _this = _possibleConstructorReturn(this, (DateRangeInput.__proto__ || Object.getPrototypeOf(DateRangeInput)).call(this, props));

    _this.handleRangeChange = function (range) {
      _this.setState({ enteredTo: null, error: false });
      var normalizedRange = _this.normalizeRange(range);
      _this.props.onChange(normalizedRange);
    };

    _this.handleDayClick = function (dayValue, modifiers) {
      if (modifiers.disabled) {
        return _possibleConstructorReturn(_this);
      }

      var day = (0, _utils.zeroTime)(dayValue);

      var from = _this.props.value[0];
      var to = _this.props.value[1];

      if (isSelectingFirstDay(from, to, day)) {
        _this.handleRangeChange([day, null]);
        _this.setState({
          enteredTo: null
        });
      } else {
        _this.handleRangeChange([from, day]);
        _this.setState({
          enteredTo: day,
          showPicker: false
        });
      }
    };

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.pickerContainer.contains(event.target);

      if (_this.variantsContainer) {
        clickedOutside = clickedOutside && !_this.variantsContainer.contains(event.target);
      }

      if (clickedOutside) {
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        // TAB key
        _this.hideVariants();
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hidePicker();
        _this.hideVariants();
      }
    };

    _this.handleVariantsButtonClick = function () {
      var _ret2;

      if (_this.state.showVariants) {
        var _ret;

        return _ret = _this.hideVariants(), _possibleConstructorReturn(_this, _ret);
      }
      return _ret2 = _this.showVariants(), _possibleConstructorReturn(_this, _ret2);
    };

    _this.handleVariantSelect = function (range) {
      _this.hideVariants();
      _this.setState({ enteredTo: range[1] });
      _this.handleRangeChange(range);
    };

    _this.handleFocus = function (e, inputName) {
      _this.props.onFocus(e, inputName);
      _this.showPicker();

      _this.setState({ focused: true });
    };

    _this.handleBlur = function (e, inputName) {
      _this.props.onBlur(e, inputName);
      _this.hideVariants();

      _this.setState({ focused: false });
    };

    _this.handleError = function () {
      _this.setState({ error: true });
    };

    _this.handleInputClick = function () {
      if (!_this.props.disabled) {
        _this.showPicker();
      }
    };

    _this.handleDayMouseEnter = function (day) {
      var from = _this.props.value[0];
      var to = _this.props.value[1];

      if (!isSelectingFirstDay(from, to, day)) {
        _this.setState({
          enteredTo: day
        });
      }
    };

    _this.handleDayMouseLeave = function (day) {
      _this.setState({ enteredTo: null });
    };

    _this.handleReset = function () {
      _this.setState(initialState);
      _this.handleRangeChange([null, null]);
      _this.dateInputFieldTo.clear();
      _this.dateInputFieldFrom.clear();
    };

    _this.state = initialState;
    return _this;
  }

  _createClass(DateRangeInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value[0] !== nextProps.value[0]) {
        var month = nextProps.value[0] || new Date();
        if (this.reactDayPicker) {
          this.reactDayPicker.showMonth(month);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _isEqual2.default)(this.state.enteredTo, nextState.enteredTo) || this.state.showPicker !== nextState.showPicker || this.state.showVariants !== nextState.showVariants || this.state.error !== nextState.error || this.state.focused !== nextState.focused || this.props.className !== nextProps.className || this.props.dateFormat !== nextProps.dateFormat || this.props.disabled !== nextProps.disabled || this.props.isValid !== nextProps.isValid || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value) || !(0, _isEqual2.default)(this.props.variants, nextProps.variants);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var rangeChanged = this.state.from !== nextState.from || this.state.to !== nextState.to;
      var rangeFilled = nextState.from !== null && nextState.to !== null;
      if (rangeChanged && rangeFilled) {
        this.handleRangeChange([nextState.from, nextState.to]);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'normalizeRange',
    value: function normalizeRange(range) {
      var from = range[0];
      var to = range[1];
      var fromGreaterThanTo = from && to && from.getTime() > to.getTime();
      if (fromGreaterThanTo) {
        return [to, from];
      }
      return range;
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      var month = this.props.value[0] || new Date();
      this.reactDayPicker.showMonth(month);
      this.setState({ showPicker: true, showVariants: false });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'showVariants',
    value: function showVariants() {
      this.setState({ showVariants: true, showPicker: false });
    }
  }, {
    key: 'hideVariants',
    value: function hideVariants() {
      this.setState({ showVariants: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          value = _props.value,
          disabled = _props.disabled,
          locale = _props.locale,
          isValid = _props.isValid,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          tabIndex = _props.tabIndex,
          showToTop = _props.showToTop,
          showToLeft = _props.showToLeft,
          variants = _props.variants,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'value', 'disabled', 'locale', 'isValid', 'onBlur', 'onChange', 'onFocus', 'tabIndex', 'showToTop', 'showToLeft', 'variants']);

      var splittedProps = (0, _utils.splitProps)(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var dayPickerSpecificProps = splittedProps[1];

      var from = this.props.value[0];
      var to = this.props.value[1];
      var _state = this.state,
          enteredTo = _state.enteredTo,
          error = _state.error,
          focused = _state.focused,
          showPicker = _state.showPicker,
          showVariants = _state.showVariants;

      var dayjsCompatibleDateFormat = dateFormat.replace(/d/g, 'D').replace(/y/g, 'Y');

      var showToTopClassName = showToTop ? 'opuscapita_date-range-input__picker-container--to-top' : '';
      var showToLeftClassName = showToLeft ? 'opuscapita_date-range-input__picker-container--to-left' : '';

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        className: 'Range',
        fixedWeeks: true,
        month: from,
        hideTodayButton: true,
        locale: locale,
        modifiers: { start: from, end: enteredTo || to },
        numberOfMonths: 2,
        isRange: true,
        onChange: this.handleRangeChange,
        onDayClick: this.handleDayClick,
        onDayMouseEnter: this.handleDayMouseEnter,
        onDayMouseLeave: this.handleDayMouseLeave,
        selectedDays: [from, { from: from, to: enteredTo || to }],
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        }
      }, dayPickerSpecificProps));

      var variantsElement = null;

      if (typeof variants !== 'undefined' && variants.length) {
        var translatedVariants = variants.map(function (variant) {
          return _extends({}, variant, {
            label: variant.getLabel(locale)
          });
        });

        variantsElement = _react2.default.createElement(_DateVariants2.default, {
          onChange: this.handleVariantSelect,
          locale: locale,
          variants: translatedVariants
        });
      }

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref) {
                return _this2.pickerContainer = _ref;
              },
              className: 'opuscapita_date-range-input__picker-container ' + showToTopClassName + ' ' + showToLeftClassName,
              style: {
                maxHeight: interpolatedStyle.x * 640 + 'px',
                opacity: easeOutCubic(interpolatedStyle.x)
              }
            },
            pickerElement
          );
        }
      );

      var variantsMotionElement = variantsElement ? _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showVariants ? 1 : 0 },
          style: { x: showVariants ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              ref: function ref(_ref2) {
                return _this2.variantsContainer = _ref2;
              },
              className: '\n              opuscapita_date-range-input__variants-container\n              ' + (showToTop ? 'opuscapita_date-range-input__variants-container--to-top' : '') + '\n            ',
              style: {
                maxHeight: interpolatedStyle.x * 640 + 'px',
                opacity: easeOutCubic(interpolatedStyle.x)
              }
            },
            variantsElement
          );
        }
      ) : null;

      var resetButton = _react2.default.createElement(
        _InputAddonButton2.default,
        {
          className: 'opuscapita_date-range-input__reset-btn',
          tabIndex: '-1',
          onClick: this.handleReset,
          disabled: disabled,
          title: (0, _translations2.default)(locale, 'common.DateInput.clearValue')
        },
        '\u2715'
      );

      var variantsButton = typeof variants !== 'undefined' && variants.length ? _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-default opuscapita_date-range-input__variants-btn',
          disabled: disabled,
          tabIndex: '-1',
          onClick: this.handleVariantsButtonClick
        },
        _react2.default.createElement('span', { className: 'caret' })
      ) : null;

      var hasErrorClassName = isValid && !error ? '' : 'has-error';
      var focusedClassName = focused ? 'opuscapita_date-range-input__input-field-container--focused' : '';

      return _react2.default.createElement(
        'div',
        _extends({
          ref: function ref(el) {
            return _this2.container = el;
          },
          className: 'opuscapita_date-range-input form-control ' + className
        }, commonProps),
        _react2.default.createElement(
          'div',
          {
            className: '\n            opuscapita_date-range-input__input-field-container\n            form-control\n            ' + hasErrorClassName + '\n            ' + focusedClassName + '\n          '
          },
          _react2.default.createElement(_DateInputField2.default, {
            className: 'opuscapita_date-range-input__input-field opuscapita_date-range-input__left-input-field',
            dateFormat: dayjsCompatibleDateFormat,
            disabled: disabled,
            error: error,
            onBlur: function onBlur(e) {
              return _this2.handleBlur(e, 'from');
            },
            onFocus: function onFocus(e) {
              return _this2.handleFocus(e, 'from');
            },
            onChange: function onChange(date) {
              return _this2.handleRangeChange([date, value[1]]);
            },
            onClick: this.handleInputClick,
            onError: this.handleError,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputFieldFrom = dateInputField;
            },
            tabIndex: tabIndex,
            value: value[0]
          }),
          _react2.default.createElement(
            'div',
            { className: 'opuscapita_date-range-input__dash' },
            '\u2015'
          ),
          _react2.default.createElement(_DateInputField2.default, {
            className: 'opuscapita_date-range-input__input-field opuscapita_date-range-input__right-input-field',
            dateFormat: dayjsCompatibleDateFormat,
            disabled: disabled,
            error: error,
            onBlur: function onBlur(e) {
              return _this2.handleBlur(e, 'to');
            },
            onFocus: function onFocus(e) {
              return _this2.handleFocus(e, 'to');
            },
            onChange: function onChange(date) {
              return _this2.handleRangeChange([value[0], date]);
            },
            onClick: this.handleInputClick,
            onError: this.handleError,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputFieldTo = dateInputField;
            },
            tabIndex: tabIndex,
            value: value[1]
          }),
          resetButton
        ),
        pickerMotionElement,
        variantsMotionElement,
        variantsButton
      );
    }
  }]);

  return DateRangeInput;
}(_react.Component);

exports.default = DateRangeInput;


DateRangeInput.propTypes = propTypes;
DateRangeInput.defaultProps = defaultProps;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(56).default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactAutocompletes = __webpack_require__(126);

var _dayjs = __webpack_require__(11);

var _dayjs2 = _interopRequireDefault(_dayjs);

__webpack_require__(122);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.array
  })),
  onChange: _propTypes2.default.func,
  locale: _propTypes2.default.string
};

var defaultProps = {
  variants: [{
    label: 'Previous week',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).subtract(7, 'days').startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).subtract(7, 'days').endOf('week').toDate()];
    }
  }, {
    label: 'This week',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).endOf('week').toDate()];
    }
  }, {
    label: 'Next week',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).add(7, 'days').startOf('week').toDate(), (0, _dayjs2.default)().locale(locale).add(7, 'days').endOf('week').toDate()];
    }
  }, {
    label: 'Previous month',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).subtract(1, 'month').startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).subtract(1, 'month').endOf('month').toDate()];
    }
  }, {
    label: 'Last 30 days',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).subtract(30, 'days').toDate(), (0, _dayjs2.default)().locale(locale).toDate()];
    }
  }, {
    label: 'This month',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).endOf('month').toDate()];
    }
  }, {
    label: 'Next month',
    getValue: function getValue(locale) {
      return [(0, _dayjs2.default)().locale(locale).add(1, 'month').startOf('month').toDate(), (0, _dayjs2.default)().locale(locale).add(1, 'month').endOf('month').toDate()];
    }
  }],
  onChange: function onChange() {},
  locale: 'en'
};

var DateVariants = function (_Component) {
  _inherits(DateVariants, _Component);

  function DateVariants() {
    _classCallCheck(this, DateVariants);

    return _possibleConstructorReturn(this, (DateVariants.__proto__ || Object.getPrototypeOf(DateVariants)).apply(this, arguments));
  }

  _createClass(DateVariants, [{
    key: 'handleChange',
    value: function handleChange(key) {
      var variants = this.props.variants;
      var value = variants[key].getValue(this.props.locale);
      this.props.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          variants = _props.variants,
          onChange = _props.onChange;

      var items = variants.map(function (variant, index) {
        return {
          key: index.toString(),
          value: variant.label
        };
      });

      var variantsElement = _react2.default.createElement(
        'li',
        { className: 'opuscapita_date-range-variants__list' },
        _react2.default.createElement(_reactAutocompletes.VerticalList, { onClick: function onClick(event, key) {
            return _this2.handleChange(key);
          }, items: items })
      );

      return _react2.default.createElement(
        'div',
        { className: 'opuscapita_date-range-variants' },
        variantsElement
      );
    }
  }]);

  return DateVariants;
}(_react.Component);

exports.default = DateVariants;


DateVariants.propTypes = propTypes;
DateVariants.defaultProps = defaultProps;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Caption;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _dayjs = __webpack_require__(32);

var _dayjs2 = _interopRequireDefault(_dayjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Caption(props) {
  var date = props.date,
      locale = props.locale,
      localeUtils = props.localeUtils,
      isRange = props.isRange,
      onChange = props.onChange,
      monthToDisplay = props.monthToDisplay;


  var months = localeUtils.getMonths(locale);

  // Fill years selectbox
  var dateNow = new Date();
  var years = [];
  for (var i = dateNow.getFullYear() - 100; i <= dateNow.getFullYear() + 100; i += 1) {
    years.push(i);
  }

  var isCaptionFrom = (date && date.getMonth()) === (monthToDisplay && monthToDisplay.getMonth());
  var captionIndex = isCaptionFrom ? 0 : 1;

  var handleChange = function handleChange(year, month) {
    if (isRange) {
      onChange({ month: month, year: year, captionIndex: captionIndex });
    } else {
      onChange({ month: month, year: year, captionIndex: 0 });
    }
  };

  var handleYearChange = function handleYearChange(event) {
    handleChange(event.target.value, date.getMonth());
  };

  var handleMonthChange = function handleMonthChange(event) {
    handleChange(date.getFullYear(), event.target.value);
  };

  if (!monthToDisplay) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'DayPicker-Caption' },
    _react2.default.createElement(
      'div',
      { className: 'form-group opuscapita_day-picker__caption' },
      _react2.default.createElement(
        'select',
        {
          className: 'opuscapita_day-picker__caption-select',
          onChange: handleMonthChange,
          name: 'month',
          value: isCaptionFrom ? monthToDisplay.getMonth() : (0, _dayjs2.default)(monthToDisplay).add(1, 'month').toDate().getMonth(),
          tabIndex: -1
        },
        months.map(function (month, index) {
          return _react2.default.createElement(
            'option',
            { key: index, value: index },
            month
          );
        })
      ),
      _react2.default.createElement(
        'select',
        {
          className: 'opuscapita_day-picker__caption-select',
          onChange: handleYearChange,
          name: 'year',
          value: isCaptionFrom ? monthToDisplay.getFullYear() : (0, _dayjs2.default)(monthToDisplay).add(1, 'month').toDate().getFullYear(),
          tabIndex: -1
        },
        years.map(function (year, index) {
          return _react2.default.createElement(
            'option',
            { key: index, value: year },
            year
          );
        })
      )
    )
  );
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _DayPicker = __webpack_require__(128);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

__webpack_require__(129);

var _reactDayPickerUtils = __webpack_require__(69);

var _reactDayPickerUtils2 = _interopRequireDefault(_reactDayPickerUtils);

var _translations = __webpack_require__(23);

var _translations2 = _interopRequireDefault(_translations);

var _utils = __webpack_require__(19);

var _Caption = __webpack_require__(59);

var _Caption2 = _interopRequireDefault(_Caption);

var _dayjs = __webpack_require__(32);

var _dayjs2 = _interopRequireDefault(_dayjs);

__webpack_require__(123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = _extends({}, _DayPicker2.default.propTypes, {
  className: _propTypes2.default.string,
  dayPickerRef: _propTypes2.default.func,
  getTodayButtonLabel: _propTypes2.default.func,
  hideTodayButton: _propTypes2.default.bool,
  isRange: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  pickerClassName: _propTypes2.default.string
});

var defaultProps = {
  className: '',
  dayPickerRef: function dayPickerRef() {},
  getTodayButtonLabel: function getTodayButtonLabel(locale) {
    return (0, _translations2.default)(locale, 'common.DateInput.today');
  },
  hideTodayButton: false,
  isRange: false,
  labels: _DayPicker2.default.defaultProps.labels,
  onChange: function onChange() {},
  pickerClassName: ''
};

var DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.handleCaptionChange = function (_ref) {
      var month = _ref.month,
          year = _ref.year,
          captionIndex = _ref.captionIndex;

      var monthToDisplay = captionIndex === 0 ? new Date(year, month) : (0, _dayjs2.default)(new Date(year, month)).subtract(1, 'month').toDate();

      _this.setState({ monthToDisplay: monthToDisplay });
    };

    _this.handleMonthChange = function (date) {
      _this.setState({ monthToDisplay: date });
    };

    _this.handleTodayClick = function () {
      _this.props.onChange((0, _utils.zeroTime)(new Date()));
    };

    _this.state = {
      date: props.date,
      monthToDisplay: props.date
    };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dayPickerRef = _props.dayPickerRef,
          isRange = _props.isRange,
          hideTodayButton = _props.hideTodayButton,
          onChange = _props.onChange,
          getTodayButtonLabel = _props.getTodayButtonLabel,
          locale = _props.locale,
          pickerClassName = _props.pickerClassName,
          restProps = _objectWithoutProperties(_props, ['className', 'dayPickerRef', 'isRange', 'hideTodayButton', 'onChange', 'getTodayButtonLabel', 'locale', 'pickerClassName']);

      var monthToDisplay = this.state.monthToDisplay;


      var splittedProps = (0, _utils.splitProps)(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var pickerSpecificProps = splittedProps[1];

      var todayButton = hideTodayButton ? null : _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-sm btn-default opuscapita_day-picker__today-button',
          onClick: this.handleTodayClick,
          tabIndex: -1
        },
        getTodayButtonLabel(locale)
      );

      var caption = _react2.default.createElement(_Caption2.default, {
        locale: locale,
        onChange: function onChange(captionData) {
          return _this2.handleCaptionChange(captionData);
        },
        isRange: isRange,
        monthToDisplay: monthToDisplay
      });

      return _react2.default.createElement(
        'div',
        _extends({ className: 'opuscapita_day-picker ' + className }, commonProps),
        _react2.default.createElement('div', { className: 'opuscapita_day-picker__header' }),
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_day-picker__picker' },
          _react2.default.createElement(_DayPicker2.default, _extends({
            ref: function ref(el) {
              return dayPickerRef(el);
            },
            className: pickerClassName,
            localeUtils: _reactDayPickerUtils2.default,
            locale: locale,
            firstDayOfWeek: locale === 'en' ? 0 : 1,
            onMonthChange: this.handleMonthChange,
            onWeekClick: function onWeekClick() {},
            captionElement: caption,
            tabIndex: -1,
            showWeekNumbers: true
          }, pickerSpecificProps, {
            month: monthToDisplay
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_day-picker__footer' },
          todayButton
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

exports.default = DayPicker;


DayPicker.propTypes = propTypes;
DayPicker.defaultProps = defaultProps;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

var defaultProps = {
  className: '',
  disabled: false,
  onClick: function onClick() {}
};

var InputAddonButton = function (_Component) {
  _inherits(InputAddonButton, _Component);

  function InputAddonButton() {
    _classCallCheck(this, InputAddonButton);

    return _possibleConstructorReturn(this, (InputAddonButton.__proto__ || Object.getPrototypeOf(InputAddonButton)).apply(this, arguments));
  }

  _createClass(InputAddonButton, [{
    key: 'handleOnClick',
    value: function handleOnClick(e) {
      if (!this.props.disabled) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          disabled = _props.disabled,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'onClick', 'disabled']);

      return _react2.default.createElement(
        'div',
        _extends({
          className: '\n          opuscapita_input-addon-button\n          ' + (disabled ? 'opuscapita_input-addon-button--disabled' : '') + '\n          ' + className,
          onClick: this.handleOnClick.bind(this)
        }, restProps),
        children
      );
    }
  }]);

  return InputAddonButton;
}(_react.Component);

exports.default = InputAddonButton;


InputAddonButton.propTypes = propTypes;
InputAddonButton.defaultProps = defaultProps;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'de',
  weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
  months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
  ordinal: function ordinal(n) {
    return n + '.';
  },
  // https://github.com/moment/moment/blob/develop/locale/de.js
  weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'en',
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
  // https://github.com/moment/moment/blob/develop/locale/en-gb.js
  ordinal: function ordinal(number) {
    var b = number % 10,
        output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
    return number + output;
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  },
  weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_')
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'es',
  weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  ordinal: function ordinal(n) {
    return n + '\xB0';
  },
  // https://github.com/moment/moment/blob/develop/locale/es.js
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://github.com/moment/moment/blob/develop/locale/fi.js
exports.default = {
  name: 'fi',
  weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
  // eslint-disable-next-line max-len
  months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
  ordinal: function ordinal(n) {
    return n + '.';
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  },
  weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_')
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://github.com/moment/moment/blob/develop/locale/nb.js
exports.default = {
  name: 'no',
  weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
  months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
  ordinal: function ordinal(n) {
    return n + '.';
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  },
  weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_')
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ru',
  weekdays: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
  months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
  ordinal: function ordinal(n) {
    return n;
  },
  // https://github.com/moment/moment/blob/develop/locale/ru.js
  weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://github.com/moment/moment/blob/develop/locale/sv.js
exports.default = {
  name: 'sv',
  weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
  months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
  ordinal: function ordinal(number) {
    var b = number % 10,
        output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
    return number + output;
  },
  weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(11);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function safeName(locale) {
  // if locale is not defined - use 'en'
  return _.locales[locale] ? locale : 'en';
}

function formatDay(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _2.default)(day).locale(safeName(locale)).format('ddd ll');
}

function formatMonthTitle(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _2.default)(date).locale(safeName(locale)).format('MMMM YYYY');
}

function formatWeekdayShort(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _.locales[safeName(locale)].weekdaysMin[day];
}

function formatWeekdayLong(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _.locales[safeName(locale)].weekdays[day];
}

function getFirstDayOfWeek() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _.locales[safeName(locale)].week.dow;
}

function getMonths() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _.locales[safeName(locale)].months;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(31)
  , toLength  = __webpack_require__(18)
  , toIndex   = __webpack_require__(44);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15)
  , document = __webpack_require__(2).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(14)
  , call        = __webpack_require__(78)
  , isArrayIter = __webpack_require__(76)
  , anObject    = __webpack_require__(12)
  , toLength    = __webpack_require__(18)
  , getIterFn   = __webpack_require__(93);
module.exports = function(iterable, entries, fn, that){
  var iterFn = getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    call(iterator, f, step.value, entries);
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2).document && document.documentElement;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(13);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(16)
  , ITERATOR   = __webpack_require__(0)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(15)
  , cof      = __webpack_require__(13)
  , MATCH    = __webpack_require__(0)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(12);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(6)
  , descriptor     = __webpack_require__(42)
  , setToStringTag = __webpack_require__(29)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(5)(IteratorPrototype, __webpack_require__(0)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(0)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(2)
  , macrotask = __webpack_require__(92).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(13)(process) == 'process'
  , head, last, notify;

var flush = function(){
  var parent, domain, fn;
  if(isNode && (parent = process.domain)){
    process.domain = null;
    parent.exit();
  }
  while(head){
    domain = head.domain;
    fn     = head.fn;
    if(domain)domain.enter();
    fn(); // <- currently we use it only for Promise - try / catch not required
    if(domain)domain.exit();
    head = head.next;
  } last = undefined;
  if(parent)parent.enter();
};

// Node.js
if(isNode){
  notify = function(){
    process.nextTick(flush);
  };
// browsers with MutationObserver
} else if(Observer){
  var toggle = 1
    , node   = document.createTextNode('');
  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
  notify = function(){
    node.data = toggle = -toggle;
  };
// environments with maybe non-completely correct, but existent Promise
} else if(Promise && Promise.resolve){
  notify = function(){
    Promise.resolve().then(flush);
  };
// for other environments - macrotask based on:
// - setImmediate
// - MessageChannel
// - window.postMessag
// - onreadystatechange
// - setTimeout
} else {
  notify = function(){
    // strange IE + webpack dev server bug - use .call(global)
    macrotask.call(global, flush);
  };
}

module.exports = function asap(fn){
  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
  if(last)last.next = task;
  if(!head){
    head = task;
    notify();
  } last = task;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(17);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var getDesc  = __webpack_require__(6).getDesc
  , isObject = __webpack_require__(15)
  , anObject = __webpack_require__(12);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(14)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(2)
  , $           = __webpack_require__(6)
  , DESCRIPTORS = __webpack_require__(26)
  , SPECIES     = __webpack_require__(0)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(12)
  , aFunction = __webpack_require__(24)
  , SPECIES   = __webpack_require__(0)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(21)
  , defined   = __webpack_require__(10);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1)
  , defined = __webpack_require__(10)
  , fails   = __webpack_require__(28)
  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec){
  var exp  = {};
  exp[KEY] = exec(trim);
  $export($export.P + $export.F * fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  }), 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(14)
  , invoke             = __webpack_require__(74)
  , html               = __webpack_require__(73)
  , cel                = __webpack_require__(71)
  , global             = __webpack_require__(2)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listner = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(13)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listner;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listner, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(25)
  , ITERATOR  = __webpack_require__(0)('iterator')
  , Iterators = __webpack_require__(16);
module.exports = __webpack_require__(4).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(38)
  , step             = __webpack_require__(81)
  , Iterators        = __webpack_require__(16)
  , toIObject        = __webpack_require__(31);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(40)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(25)
  , test    = {};
test[__webpack_require__(0)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(17)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $          = __webpack_require__(6)
  , LIBRARY    = __webpack_require__(41)
  , global     = __webpack_require__(2)
  , ctx        = __webpack_require__(14)
  , classof    = __webpack_require__(25)
  , $export    = __webpack_require__(1)
  , isObject   = __webpack_require__(15)
  , anObject   = __webpack_require__(12)
  , aFunction  = __webpack_require__(24)
  , strictNew  = __webpack_require__(89)
  , forOf      = __webpack_require__(72)
  , setProto   = __webpack_require__(85).set
  , same       = __webpack_require__(84)
  , SPECIES    = __webpack_require__(0)('species')
  , speciesConstructor = __webpack_require__(88)
  , asap       = __webpack_require__(82)
  , PROMISE    = 'Promise'
  , process    = global.process
  , isNode     = classof(process) == 'process'
  , P          = global[PROMISE]
  , empty      = function(){ /* empty */ }
  , Wrapper;

var testResolve = function(sub){
  var test = new P(empty), promise;
  if(sub)test.constructor = function(exec){
    exec(empty, empty);
  };
  (promise = P.resolve(test))['catch'](empty);
  return promise === test;
};

var USE_NATIVE = function(){
  var works = false;
  function P2(x){
    var self = new P(x);
    setProto(self, P2.prototype);
    return self;
  }
  try {
    works = P && P.resolve && testResolve();
    setProto(P2, P);
    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
    // actual Firefox has broken subclass support, test that
    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
      works = false;
    }
    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
    if(works && __webpack_require__(26)){
      var thenableThenGotten = false;
      P.resolve($.setDesc({}, 'then', {
        get: function(){ thenableThenGotten = true; }
      }));
      works = thenableThenGotten;
    }
  } catch(e){ works = false; }
  return works;
}();

// helpers
var sameConstructor = function(a, b){
  // library wrapper special case
  if(LIBRARY && a === P && b === Wrapper)return true;
  return same(a, b);
};
var getConstructor = function(C){
  var S = anObject(C)[SPECIES];
  return S != undefined ? S : C;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var PromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve),
  this.reject  = aFunction(reject)
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(record, isReject){
  if(record.n)return;
  record.n = true;
  var chain = record.c;
  asap(function(){
    var value = record.v
      , ok    = record.s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , result, then;
      try {
        if(handler){
          if(!ok)record.h = true;
          result = handler === true ? value : handler(value);
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    chain.length = 0;
    record.n = false;
    if(isReject)setTimeout(function(){
      var promise = record.p
        , handler, console;
      if(isUnhandled(promise)){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      } record.a = undefined;
    }, 1);
  });
};
var isUnhandled = function(promise){
  var record = promise._d
    , chain  = record.a || record.c
    , i      = 0
    , reaction;
  if(record.h)return false;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var $reject = function(value){
  var record = this;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  record.v = value;
  record.s = 2;
  record.a = record.c.slice();
  notify(record, true);
};
var $resolve = function(value){
  var record = this
    , then;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  try {
    if(record.p === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      asap(function(){
        var wrapper = {r: record, d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      record.v = value;
      record.s = 1;
      notify(record, false);
    }
  } catch(e){
    $reject.call({r: record, d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  P = function Promise(executor){
    aFunction(executor);
    var record = this._d = {
      p: strictNew(this, P, PROMISE),         // <- promise
      c: [],                                  // <- awaiting reactions
      a: undefined,                           // <- checked in isUnhandled reactions
      s: 0,                                   // <- state
      d: false,                               // <- done
      v: undefined,                           // <- value
      h: false,                               // <- handled rejection
      n: false                                // <- notify
    };
    try {
      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
    } catch(err){
      $reject.call(record, err);
    }
  };
  __webpack_require__(83)(P.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction = new PromiseCapability(speciesConstructor(this, P))
        , promise  = reaction.promise
        , record   = this._d;
      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      record.c.push(reaction);
      if(record.a)record.a.push(reaction);
      if(record.s)notify(record, false);
      return promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
__webpack_require__(29)(P, PROMISE);
__webpack_require__(86)(PROMISE);
Wrapper = __webpack_require__(4)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = new PromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof P && sameConstructor(x.constructor, this))return x;
    var capability = new PromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(80)(function(iter){
  P.all(iter)['catch'](function(){});
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject
      , values     = [];
    var abrupt = perform(function(){
      forOf(iterable, false, values.push, values);
      var remaining = values.length
        , results   = Array(remaining);
      if(remaining)$.each.call(values, function(promise, index){
        var alreadyCalled = false;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled = true;
          results[index] = value;
          --remaining || resolve(results);
        }, reject);
      });
      else resolve(results);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(20)('match', 1, function(defined, MATCH){
  // 21.1.3.11 String.prototype.match(regexp)
  return function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  };
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(20)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  };
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(20)('search', 1, function(defined, SEARCH){
  // 21.1.3.15 String.prototype.search(regexp)
  return function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  };
});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(20)('split', 2, function(defined, SPLIT, $split){
  // 21.1.3.17 String.prototype.split(separator, limit)
  return function split(separator, limit){
    'use strict';
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined
      ? fn.call(separator, O, limit)
      : $split.call(String(O), separator, limit);
  };
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1)
  , $at     = __webpack_require__(43)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(1)
  , toLength  = __webpack_require__(18)
  , context   = __webpack_require__(30)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(27)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , $$   = arguments
      , endPosition = $$.length > 1 ? $$[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(1)
  , toIndex        = __webpack_require__(44)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res   = []
      , $$    = arguments
      , $$len = $$.length
      , i     = 0
      , code;
    while($$len > i){
      code = +$$[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(1)
  , context  = __webpack_require__(30)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(27)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(1)
  , toIObject = __webpack_require__(31)
  , toLength  = __webpack_require__(18);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl   = toIObject(callSite.raw)
      , len   = toLength(tpl.length)
      , $$    = arguments
      , $$len = $$.length
      , res   = []
      , i     = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < $$len)res.push(String($$[i]));
    } return res.join('');
  }
});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(90)
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(1)
  , toLength    = __webpack_require__(18)
  , context     = __webpack_require__(30)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(27)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , $$     = arguments
      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(91)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(1)
  , $includes = __webpack_require__(70)(true);

$export($export.P, 'Array', {
  // https://github.com/domenic/Array.prototype.includes
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(38)('includes');

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
var global      = __webpack_require__(2)
  , hide        = __webpack_require__(5)
  , Iterators   = __webpack_require__(16)
  , ITERATOR    = __webpack_require__(0)('iterator')
  , NL          = global.NodeList
  , HTC         = global.HTMLCollection
  , NLProto     = NL && NL.prototype
  , HTCProto    = HTC && HTC.prototype
  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_date-input {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  padding: 0 !important;\n  border: none !important;\n  position: relative !important;\n}\n.opuscapita_date-input__input-container {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n}\n.opuscapita_date-input .opuscapita_date-input-field {\n  padding-right: 4ch;\n}\n.opuscapita_date-input-field input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n}\n.opuscapita_date-input-field input:disabled {\n  background: transparent;\n}\n.opuscapita_date-input__picker-container,\n.opuscapita_date-input__variants-container {\n  will-change: opacity, max-height;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  position: absolute;\n  overflow: hidden;\n  z-index: 9999;\n  bottom: -4px;\n  transform: translate(0, 100%);\n}\n.opuscapita_date-input__picker-container {\n  left: 0;\n}\n.opuscapita_date-input__variants-container {\n  white-space: nowrap;\n  right: 0;\n  left: auto;\n}\n.opuscapita_date-input__variants-container--to-top,\n.opuscapita_date-input__picker-container--to-top {\n  bottom: auto;\n  top: -4px;\n  transform: translate(0, -100%);\n}\n.opuscapita_date-input__picker-container--to-left {\n  left: 0;\n}\n.opuscapita_date-input__variants-btn {\n  border-left: none;\n}\n.opuscapita_date-input__picker-container:focus {\n  outline: none;\n}\n.opuscapita_date-input__reset-btn {\n  position: absolute;\n  top: 0;\n  right: 1ch;\n  z-index: 2;\n}\n", ""]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_date-input-field {\n  z-index: 1 !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.opuscapita_date-input-field__input::-ms-clear {\n  display: none !important;\n}\n.opuscapita_date-input-field__input:-ms-input-placeholder {\n  color: #999;\n}\n.opuscapita_date-input-field__input::placeholder {\n  color: #999;\n}\n.opuscapita_date-input-field__input::-moz-placeholder {\n  color: #999;\n}\n.opuscapita_date-input-field__input::-webkit-input-placeholder {\n  color: #999;\n}\n.opuscapita_date-input-field__input:-ms-input-placeholder {\n  color: #999;\n}\n.opuscapita_date-input-field__input::-ms-input-placeholder {\n  color: #999;\n}\n", ""]);

// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_date-picker {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.opuscapita_date-picker__picker-container {\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  position: absolute;\n  z-index: 9999;\n  left: 0;\n  bottom: -4px;\n  transform: translate(0, 100%);\n}\n.opuscapita_date-picker__picker-container:focus {\n  outline: none;\n}\n.opuscapita_date-picker__picker-container--to-top {\n  bottom: auto;\n  top: -4px;\n  transform: translate(0, -100%);\n}\n.opuscapita_date-picker__picker-container--to-left {\n  left: auto;\n  right: 0;\n}\n", ""]);

// exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_date-range-input {\n  position: relative !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n  padding: 0 !important;\n  border: none !important;\n}\n.opuscapita_date-range-input__picker-container,\n.opuscapita_date-range-input__variants-container {\n  will-change: opacity, max-height;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  position: absolute;\n  z-index: 9999;\n  bottom: -4px;\n  transform: translate(0, 100%);\n}\n.opuscapita_date-range-input__picker-container {\n  left: 0;\n}\n.opuscapita_date-range-input__variants-container {\n  right: 0;\n  left: auto;\n  white-space: nowrap;\n}\n.opuscapita_date-range-input__picker-container:focus {\n  outline: none;\n}\n.opuscapita_date-range-input__picker-container .DayPicker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_date-range-input__reset-btn {\n  position: absolute;\n  top: 0;\n  right: 1ch;\n  z-index: 1;\n}\n.opuscapita_date-range-input__input-field {\n  width: 100% !important;\n  height: 100% !important;\n  border: none !important;\n  text-align: center;\n  box-shadow: none !important;\n}\n.opuscapita_date-range-input__left-input-field {\n  padding-right: 24px;\n}\n.opuscapita_date-range-input__left-input-field input {\n  text-align: left;\n}\n.opuscapita_date-range-input__right-input-field {\n  padding-right: 36px;\n}\n.opuscapita_date-range-input__right-input-field input {\n  text-align: right;\n}\n.opuscapita_date-range-input__input-field[placeholder] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.opuscapita_date-range-input__input-field-container {\n  position: relative !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex: 1 !important;\n      flex: 1 !important;\n  padding: 0 !important;\n}\n.opuscapita_date-range-input__input-field-container--focused {\n  border-color: #369 !important;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(51, 102, 153, 0.6) !important;\n}\n.opuscapita_date-range-input__input-field-container.has-error {\n  border-color: #a94442 !important;\n}\n.opuscapita_date-range-input__input-field-container--focused.has-error {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483 !important;\n}\n.opuscapita_date-range-input__variants-btn {\n  border-left: none;\n}\n.opuscapita_date-range-input__humanized-duration {\n  position: absolute;\n  left: 0;\n  font-size: 0.8em;\n  opacity: 0.6;\n  bottom: -2px;\n  transform: translate(0, 100%);\n}\n.opuscapita_date-range-input__dash {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  z-index: 1;\n  pointer-events: none;\n  color: #aaa;\n  padding-right: 24px;\n}\n.opuscapita_date-range-input__picker-container--to-left {\n  left: auto;\n  right: 0;\n}\n.opuscapita_date-range-input__picker-container--to-top,\n.opuscapita_date-range-input__variants-container--to-top {\n  bottom: auto;\n  top: -4px;\n  transform: translate(0, -100%);\n}\n", ""]);

// exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_date-range-variants__list {\n  list-style: none;\n  padding: 0;\n}\n", ""]);

// exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_day-picker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.opuscapita_day-picker__picker {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_day-picker__picker abbr {\n  border-bottom: none;\n  cursor: default;\n  text-decoration: none;\n}\n.opuscapita_day-picker__picker .DayPicker {\n  padding-top: 0;\n}\n.opuscapita_day-picker,\n.opuscapita_day-picker__picker:focus,\n.opuscapita_day-picker__picker .DayPicker,\n.opuscapita_day-picker__picker .DayPicker-Day:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-Day {\n  border: none;\n  position: relative;\n  transition: transform 0.1s ease;\n}\n.opuscapita_day-picker__picker .DayPicker-Day:active:focus:not(.DayPicker-Day--disabled) {\n  z-index: 10;\n  transform: scale(1.4);\n}\n.opuscapita_day-picker__picker .DayPicker-Day:focus:not(.DayPicker-Day--disabled) {\n  transform: scale(1);\n}\n.DayPicker-Day--disabled.DayPicker-Day--outside {\n  pointer-events: none;\n}\n.opuscapita_day-picker__picker .DayPicker-wrapper {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_day-picker__picker .DayPicker-wrapper:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-WeekNumber:hover {\n  cursor: default;\n}\n.opuscapita_day-picker__picker .DayPicker-WeekNumber:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-Day:not(.DayPicker-Day--outside):hover:after {\n  background: #000;\n  bottom: 0;\n  content: '';\n  left: 0;\n  opacity: 0.075;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.opuscapita_day-picker__picker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  background-color: #EC6608;\n}\n.opuscapita_day-picker__picker .DayPicker-Day--today {\n  font-weight: 600;\n  color: #000;\n}\n.opuscapita_day-picker__picker .DayPicker-NavBar {\n  z-index: 9999;\n}\n.opuscapita_day-picker__picker .DayPicker-NavButton:focus {\n  outline: none;\n}\n.opuscapita_day-picker__footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.opuscapita_day-picker__today-button {\n  border-left: none;\n  border-right: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.opuscapita_day-picker__caption {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 1.6em;\n  position: relative;\n  top: -2px;\n}\n.opuscapita_day-picker__caption-select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: transparent;\n  border: none;\n  position: relative;\n  padding: 0 8px;\n}\n.opuscapita_day-picker__caption-select::-ms-expand {\n  display: none;\n}\n.opuscapita_day-picker__caption-select:hover {\n  cursor: pointer;\n}\n.opuscapita_day-picker__caption-select:focus {\n  outline: none;\n}\n", ""]);

// exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".opuscapita_input-addon-button {\n  border-left: none;\n  color: #aaa;\n  width: 3ch;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100%;\n}\n.opuscapita_input-addon-button:focus {\n  outline: none;\n}\n.opuscapita_input-addon-button:hover:not(.opuscapita_input-addon-button--disabled) {\n  color: #666;\n  cursor: pointer;\n}\n.opuscapita_input-addon-button--disabled {\n  cursor: not-allowed;\n}\n", ""]);

// exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(111);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInput.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInput.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(112);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInputField.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInputField.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(113);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DatePicker.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DatePicker.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(114);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateRangeInput.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateRangeInput.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(115);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateVariants.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateVariants.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(116);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DayPicker.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DayPicker.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(117);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./InputAddonButton.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./InputAddonButton.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = require("@opuscapita/i18n/lib/converters/DateConverter");

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = require("@opuscapita/react-autocompletes");

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = require("react-day-picker");

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = require("react-day-picker/lib/src/DayPicker");

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = require("react-day-picker/lib/style.css");

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(48);
__webpack_require__(50);
module.exports = __webpack_require__(47);


/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ./~/@opuscapita/react-dates/lib/index.js
// module id = 1509
// module chunks = 0